<script type="text/ecmascript-6">
    import TileQuestion from "../mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Choose closer:';
                }
            },
            component_id: {
                default(){
                    return 'closer';
                }
            },
            slab: {
                required: true,
            },
            slabWidth: {
                required: true,
            },
            doorRange: {
                required: true,
            },
        },
        computed: {
            thumbURL(){
                return '/thumb/hardware/';
            },
            passed_filter(){
                return this.variable_ready(this.slab, this.doorRange);
            },
            url(){
                return '/api/options/' + this.fabricator + '/closer'
                    + '?door_range=' + this.doorRange
                    + '&slab=' + this.slab
                    + '&slab_width=' + this.slabWidth;
            },
            cache_key(){
                return '_' + this.doorRange + '_' + + this.slab + '_' + this.slabWidth;
            },
        },
        watch: {
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'slabWidth': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
